// extracted by mini-css-extract-plugin
export default {"imageContainer":"FavoriteDiagnosisSearchItem_imageContainer__sj78W","image":"FavoriteDiagnosisSearchItem_image__n0YhV","description":"FavoriteDiagnosisSearchItem_description__Au3Cc"};